var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4349",
    "data-name": "Group 4349",
    transform: "translate(-1549 -202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4153",
    "data-name": "Rectangle 4153",
    width: 22,
    height: 18,
    transform: "translate(1549 202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M13.462,11.723l6.087-6.087,1.739,1.739L15.2,13.462l6.087,6.087-1.739,1.739L13.462,15.2,7.375,21.288,5.636,19.549l6.087-6.087L5.636,7.375,7.375,5.636Z",
    transform: "translate(1546.538 197.538)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelButton);
export default __webpack_public_path__ + "static/media/cancelButton.6cac9863453dbca470b957cf12daa6e3.svg";
export { ForwardRef as ReactComponent };